export default "__VITE_ASSET__BLsO3Omd__"